module.exports = {"id":"200469","name":"Lukas Rupp","rating":"76","photo":"./data/images/photos/3/200469.png","club":{"name":"1899 Hoffenheim","logo":"./data/images/clubs/1899Hoffenheim.png"},"positions":["MC","MD","MDC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LukasRupp0.json
// module id = 2640
// module chunks = 0